import React from "react";
import {
  FieldValues,
  FormProvider,
  UseFormProps,
  useForm,
} from "react-hook-form";

export interface HookFormProviderProps
  extends UseFormProps<FieldValues, Object> {
  children?: React.ReactNode;
}
export const HookFormProvider = (props: HookFormProviderProps) => {
  const { children, ...rest } = props;
  const methods = useForm(rest);
  return <FormProvider {...methods}>{children}</FormProvider>;
};
